import React, { useEffect, useState } from "react";
import { Box, Button, Grid2, Stack, Chip, Autocomplete, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useParams } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { IoMdSearch } from "react-icons/io";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useGetSubmittedManpowerQuery } from "store/slices/apis/manpowerSlice";
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const columns = [
    {
        name: "Manpower ID",
        field: "manpowerNumber",
        renderer(params) {
            return (
                <Stack direction="row" spacing={1}>
                    {params?.manpowerNumber &&
                        <Chip label={params?.manpowerNumber} size="small" sx={{
                            fontSize: '12px',
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px',
                                fontWeight: 600
                            }
                        }} />
                    }
                </Stack>
            );
        }
    },
    {
        name: "Category",
        field: "category"
    },
    {
        name: "Date",
        field: "date"
    },
    {
        name: "Plan Qty",
        field: "planQuantity"
    },
    {
        name: "Plan Manpower",
        field: "plannedManpower"
    },
    {
        name: "Actual Qty",
        field: "actualQuantity"
    },
    {
        name: "Actual Manpower",
        field: "actualManpower",
    },
    {
        name: "Status",
        field: "status",
    }
];

const categories = [
    { label: "Fasade Concrete", year: 1994 },
    { label: "Fasade Plaster", year: 1972 },
    { label: "Mason Concrete", year: 1973 }
];

const SubmittedByMeManpower = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [pageNumber, setPageNumber] = useState(1);
    const [isIssueReject, setIsIssueReject] = useState(false);
    const [rowData, setRowData] = useState(null);
    const [fullObjectData, setFullObjectData] = useState(null);
    const [isIssueApprove, setIsIssueApprove] = useState(false);
    const { projectId } = useParams();
    const [approvedStatus, setApprovedStatus] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [filters, setFilters] = useState({
        category: "",
        fromDate: "",
        toDate: "",
    });
    const [category, setCategory] = useState('');
    const {
        data: submittedManpowerList,
        refetch,
        isLoading,
    } = useGetSubmittedManpowerQuery({
        ProjectId: projectId,
        sortBy: "createddate",
        sortOrder: "desc",
        fromDate: filters?.fromDate,
        toDate: filters?.toDate,
        category: filters?.category,
        page: pageNumber,
        pageSize: 20,
    });


    const [issueData, setEditIssueData] = useState(null);
    const [isViewIssueModal, setIsViewIssueModal] = useState(false);


    useEffect(() => {
        refetch();
    }, []);

    const openNotification = async (msg, type = "error") => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: {
                    color: type,
                },
                close: false,
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);
    };

    const handleActionAcceptIssue = (row) => {
        setIsIssueApprove((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    };

    const handleCancelIssue = (row) => {
        setIsIssueApprove((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    };

    const handleCancelReject = (row) => {
        setIsIssueReject((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    };

    const handleActionView = (row) => {
        setIsViewIssueModal(!isViewIssueModal);
        if (!issueData) {
            setEditIssueData(row);
        } else {
            setEditIssueData(null);
        }
    };

    const handleActionRejectIssue = (row) => {
        setIsIssueReject((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    };
    const CustomCalendarIcon = (props) => (
        <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
      );

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: "20px" }}>
                <Grid2 size={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: { xs: 'start', sm: 'center' },
                            justifyContent: "space-between",
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                    >
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            sx={{
                                // flexGrow: 2,
                                alignItems: { xs: "stretch", sm: "center" },
                                width: { xs: '100%', sm: 'none', md: 'none', lg: 'none' },
                                "& .MuiStack-root": {
                                    paddingTop: "15px",
                                },
                            }}
                        >
                            <Autocomplete
                                options={categories}
                                getOptionLabel={(option) => option?.label}
                                onChange={(_, newValue) =>
                                    setCategory(newValue ? newValue?.label : '')
                                }
                                value={categories?.find((option) => option.label === category) || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Category"
                                        name="currentStatus"
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                padding: '8px !important', // Remove wrapper padding
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{
                                    sx: { fontSize: '13px' },
                                }}
                                sx={{
                                    width: {
                                        xs: '100%',
                                        sm: '17%',
                                        md: '17%',
                                        lg: '17%'
                                    },
                                    marginTop: '15px !important'
                                }}
                            />
                            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="From Date"
                                        value={fromDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setFromDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    minWidth: 100,
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: "",
                                                        toDate: toDate
                                                            ? dayjs(toDate).format("YYYY-MM-DD")
                                                            : "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate}
                                        format="DD-MM-YYYY"
                                        clearable={true}
                                        onChange={(newValue) => setToDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    minWidth: 100,
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: fromDate
                                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                                            : "",
                                                        toDate: "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    setFilters({
                                        fromDate: fromDate
                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                            : "",
                                        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                                        category: category
                                    });
                                }}
                                size="large"
                                startIcon={<IoMdSearch />}
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Search
                            </Button>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    setCategory("");
                                    setFromDate(null)
                                    setToDate(null)
                                    const clearedValues = Object.fromEntries(
                                        Object.keys(filters).map(key => [key, ""])
                                    );
                                    setFilters(clearedValues);
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Reset
                            </Button>
                        </Stack>
                    </Box>
                </Grid2>
                <Grid2 size={12} sx={{ mt: 2 }}>
                    <TableComponent
                        columns={columns}
                        data={submittedManpowerList?.data?.manpowerTracking}
                        actionView={handleActionView}
                        actionAccept={handleActionAcceptIssue}
                        actionReject={handleActionRejectIssue}
                        isLoading={isLoading}
                    />
                    {!isLoading && (
                        <Box sx={{ display: "flex", justifyContent: "end" }}>
                            <PaginationComponent
                                pageNumber={submittedManpowerList?.data?.pagination?.currentPage || 1}
                                totalPages={submittedManpowerList?.data?.pagination?.totalPages || 1}
                                onPageChange={setPageNumber}
                            />
                        </Box>
                    )}
                </Grid2>
            </Grid2>
        </>
    );
};

export default SubmittedByMeManpower;
